import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {NetworkPartner} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  networkPartnerId: string,
  networkPartnerName: string
}

interface IResponseBaseStore {
  termsAndConditions: string,
  privacyPolicy: string
}

interface SearchResponse {
  networkPartner: IResponseItem[]
}

@Injectable({
  providedIn: 'root'
})
export class NetworkPartnerConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/access/networkpartner';
  private baseStoreRoute = '/basestores/';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  private static transformFromApi(response: IResponseItem): NetworkPartner {
    return {
      id: response.networkPartnerId,
      name: response.networkPartnerName
    };
  }

  loadNetworkPartnerTermsAndConditionsContent(nwpId: string): Observable<string> {
    return this.http.get<IResponseBaseStore>(this.getOneBaseStoreUrl(nwpId)).pipe(
      map(
        (response: IResponseBaseStore) => response.termsAndConditions
      ),
      catchError(error => throwError('Could not load BaseStore.', error))
    )
  }

  loadNetworkPartnerPrivacyPolicyContent(nwpId: string): Observable<string> {
    return this.http.get<IResponseBaseStore>(this.getOneBaseStoreUrl(nwpId)).pipe(
      map(
        (response: IResponseBaseStore) => response.privacyPolicy
      ),
      catchError(error => throwError('Could not load BaseStore.', error))
    )
  }

  getAll(): Observable<NetworkPartner[]> {
    return this.http.get<SearchResponse>(this.getManyUrl()).pipe(
      map((response: SearchResponse) => response.networkPartner.map(
        (responseItem: IResponseItem) => NetworkPartnerConnectors.transformFromApi(responseItem))
      ),
      catchError(error => {
        console.error('Load NetworkPartner error', error);
        return throwError('NetworkPartner could not be loaded!');
      })
    );
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  protected getOneUrl(id: number) {
    return this._rootUrl + this.route + id;
  }

  protected getOneBaseStoreUrl(id: string) {
    return this._rootUrl + this._baseSite + this.baseStoreRoute + id;
  }
}
